import {
    all,
    put,
    takeEvery,
    select,
} from 'redux-saga/effects';
import {
    loadApi,
    updateFolderApi,
    addFolderApi,
    deleteFolderApi
} from '../../../helpers/folderApi'

import {
    EDIT_FOLDER_SAGA,
    FETCH_FOLDERS_SAGA,
    ADD_FOLDER_SAGA,
    ADD_FOLDER_AND_ADVERISER_SAGA,
    DELETE_FOLDER_SAGA,
    deleteFolder,
    fetchFolders,
    addFolder,
    editFolder,
    loadingFolder,
    loadedFolder,
    getFolders,
    toggleFolderModal,
    loadingSingleFolder,
    loadedSingleFolder,
} from './folder'
import { queryFolderSaga } from './mentions/saga';
import { updateAdvertiser } from './advertiser';
import { removeAdvertiserSaga } from './advertiserSaga';
import { showToast } from './notification';
import { validateFolderName } from "../../../helpers/validate"
import { ROUTE_HOME, ROUTE_ADVERTISER } from 'modules/routing';
import _ from 'lodash'
import constants from '../../../helpers/constant'
import { modules } from 'veritone-redux-common';

const {
    config: { getConfig }
} = modules;

export function* fetchDataSaga(action) {
    yield put(loadingFolder());
    const config = yield select(getConfig)
    const data = yield loadApi(config.urlApi);
    
    yield put(fetchFolders(data));
    yield put(loadedFolder());
    yield* queryFolderSaga();
}


function* editfolderSaga(action) {
    const folder = action.folder
    const { folder_id } = folder
    const config = yield select(getConfig)
    const folders = yield select(getFolders);
    const errMsg = validateFolderName(_.get(folder, 'folder_name', ""), folders);
    if (errMsg) {
        yield put(editFolder({ ...folder, errMsg }));
        return;
    }
    yield put(loadingSingleFolder(folder_id))

    const data = yield updateFolderApi(config.urlApi, folder)
    if (data.error) {
        const toast = {
            message: "Something went wrong updating a Folder",
            action: "Dismiss",
            type: constants.FAILED
        }
        return yield put(showToast(toast));
    }
    const newFolder = data.folder
    yield put(editFolder(newFolder));
    const toast = {
        message: "Folder edited",
        action: "Dismiss",
        type: constants.SUCCESS
    }
    yield put(showToast(toast))
    yield put(loadedSingleFolder(folder_id))

}

function* addFolderSaga(action) {
    let folder = action.folder
    const state = yield select()
    const folders = yield select(getFolders);
    const config = yield select(getConfig)
    const errMsg = validateFolderName(_.get(folder, 'folder_name', ""), folders);
    if (errMsg) {
        yield put(editFolder({ ...folder, errMsg }));
        return;
    }
    const { currentFolderId } = folder;
    let data = null;

    yield put(loadingSingleFolder(folder.folder_id))
    if (currentFolderId) {
        data = yield updateFolderApi(config.urlApi, { ...folder, folder_id: currentFolderId });
        if (data.error) {
            const toast = {
                message: "Something went wrong updating a Folder",
                action: "Dismiss",
                type: constants.FAILED
            }
            return yield put(showToast(toast));
        }
        yield put(editFolder(data))
    } else {
        data = yield addFolderApi(config.urlApi, folder.folder_name);
        if (data.error) {
            const toast = {
                message: "Something went wrong creating a Folder",
                action: "Dismiss",
                type: constants.FAILED
            }
            return yield put(showToast(toast));
        }
        yield put(addFolder(data));
    }

    // get advertiser editing here
    const advertiserEditing = _.get(state, 'advertiser.byId.editing', undefined)
    const type = _.get(state, 'location.type', "")
    if (!!advertiserEditing && (type == "router/ROUTE_ADVERTISER_EDIT" || type == "route/ROUTE_ADVERTISER")) {
        yield put(updateAdvertiser({ ...advertiserEditing, folder_id: data.folder_id, folder_name: data.folder_name }))
    }
    //update data folder -> expect data respone is folder created
    const toast = !currentFolderId ? {
        message: "New folder added",
        action: "Dismiss",
        type: constants.SUCCESS
    } : {
            message: "Folder edited",
            action: "Dismiss",
            type: constants.SUCCESS
        }
    yield put(showToast(toast));
    yield put(toggleFolderModal(false, data.folder_id))
    yield put(loadedSingleFolder(folder.folder_id))
    return data;
}

function* addFolderAndAdveriserSaga(action) {
    const newFolder = yield* addFolderSaga(action);
    if (!newFolder) {
        return;
    }
    yield put(updateAdvertiser({ folder_id: newFolder.folder_id, advertiser_id: 'editing' }));
    yield put({ type: ROUTE_ADVERTISER })
}

function* deleteFolderSaga(action) {
    const { folder } = action;
    const { advertisers, folder_id } = folder
    const config = yield select(getConfig)
    yield put(loadingSingleFolder(folder_id))
    const removeAdvertiserActions = advertisers.map(advertiserId => ({
        payload: {
            advertiser: {
                advertiser_id: advertiserId,
            },
            isShowToast: false
        }
    }));

    // delete all advertiser inside the folder
    removeAdvertiserActions.length > 0 && (
        yield put(showToast({
            message: removeAdvertiserActions === 1 ? "Deleting Folder & Advertiser" : "Deleting Folder & Advertisers",
            action: "Dismiss",
            type: constants.SUCCESS
        }))
    )
    for (let i = 0; i < removeAdvertiserActions.length; i++) {
        yield* removeAdvertiserSaga(removeAdvertiserActions[i])
    }

    const data = yield deleteFolderApi(config.urlApi, folder.folder_id)
    if (data.error) {
        const toast = {
            message: "Something went wrong deleting folder",
            action: "Dismiss",
            type: constants.FAILED
        }
        return yield put(showToast(toast));
    }
    yield put(deleteFolder(folder))
    yield put({ type: ROUTE_HOME });
    let messageDeleted = "";
    switch (advertisers.length) {
        case 0:
            messageDeleted = "Folder Deleted";
            break;
        case 1:
            messageDeleted = "Folder & Advertiser Deleted";
            break;
        default:
            messageDeleted = "Folder & Advertisers Deleted";
            break;
    }
    const toast = {
        message: messageDeleted,
        action: "Dismiss",
        type: constants.SUCCESS
    }
    yield put(showToast(toast))
}



export default function* auth() {
    yield all([
        takeEvery(FETCH_FOLDERS_SAGA, fetchDataSaga),
        takeEvery(EDIT_FOLDER_SAGA, editfolderSaga),
        takeEvery(ADD_FOLDER_SAGA, addFolderSaga),
        takeEvery(DELETE_FOLDER_SAGA, deleteFolderSaga),
        takeEvery(ADD_FOLDER_AND_ADVERISER_SAGA, addFolderAndAdveriserSaga),
    ]);
}
